export const API =
  process.env.REACT_APP_API_URL || "https://nova-backend-lu2l.onrender.com";
